import { format as Format } from './';

export const indexes = [Format.A4, Format.A3, Format.Letter];

export const refColCount = 12;
export const refRowHeight = 20; //pixels
export const refPadding = 14; //pixels
// Changed in #41502
//export const referenceWidth = 1480; //pixels
export const referenceWidth = 1858; //pixels
export const pixToMm = 300 / 79.375; //pixels/mm
